import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { setCookie, getCookie } from '@/utils/support'

const user = {
  state: {
    token: getToken(),
    userId: getCookie("userId"),
    parentId: '',
    name: '',
    avatar: getCookie("avatar"),
    roles: [],
    isFirstLogin: getCookie("isFirstLogin"),
    audit: getCookie("audit"),
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
      setCookie("avatar", avatar)
    },
    SET_USERID: (state, userId) => {
      state.userId = userId
      setCookie("userId", userId)
    },
    SET_ISFIRSTLOGIN: (state, isFirstLogin) => {
      state.isFirstLogin = isFirstLogin
      setCookie("isFirstLogin", isFirstLogin)
    },
    SET_PARENTID: (state, parentId) => {
      state.parentId = parentId
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_APPLECODE: (state, applyCode) => {
      state.applyCode = applyCode
    },
    SET_AUDIT: (state, audit) => {
      state.audit = audit
      setCookie("audit", audit)
    },
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {

        login(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead + data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          commit('SET_ISFIRSTLOGIN', data.isFirstLogin)
          if (userInfo.type == 1) {
            resolve(response.data.isService)
          } else {
            // 修复供应商端--添加管理员--使用管理账号登录后跳转了入驻页面【此处应该后台直接判断处理才合理】
            if (!response.data.isMcht && response.data.isParentId) {
              response.data.isMcht = response.data.isParentId
            }
            resolve(response.data.isMcht)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          commit('SET_USERID', data.userId)
          commit('SET_PARENTID', data.parentId)
          commit('SET_APPLECODE', data.applyCode)
          commit('SET_AUDIT', data.audit)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js